import { render, staticRenderFns } from "./ColSalvageStart.vue?vue&type=template&id=a602c764&scoped=true"
import script from "./ColSalvageStart.vue?vue&type=script&lang=js"
export * from "./ColSalvageStart.vue?vue&type=script&lang=js"
import style0 from "./ColSalvageStart.vue?vue&type=style&index=0&id=a602c764&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a602c764",
  null
  
)

export default component.exports